/* jscs:disable requireSpacesInsideJsxExpressionContainers */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TrayTitle } from '@ux/tray-menu';
import { golf } from '../enums';
import eidBuilder from '../eid';
import { IntlProvider, FormattedMessage } from 'react-intl';
import Link from '@ux/link';
import DropRight from '@ux/icon/drop-right';

/**
 * Render UserDetails in account tray after login.
 * Only used for resellers
 *
 * @Constructor
 * @class UserDetails
 * @api public
 */
class UserDetails extends Component {
  constructor(props) {
    super(...arguments);

    this.eids = {
      proDashboard: eidBuilder({
        key: golf.proDashboard,
        manifest: props.manifest
      }),

      visitMyAccount: eidBuilder({
        key: golf.visitMyAccount,
        manifest: props.manifest
      }),

      manageAccount: eidBuilder({
        key: golf.manageAccount,
        manifest: props.manifest
      }),

      accountSettings: eidBuilder({
        key: golf.accountSettings,
        manifest: props.manifest
      }),

      viewPin: eidBuilder({
        key: golf.viewPin,
        manifest: props.manifest
      }),

      products: eidBuilder({
        key: golf.myProducts,
        manifest: props.manifest
      }),

      renewals: eidBuilder({
        key: golf.renewals,
        manifest: props.manifest
      }),

      logout: eidBuilder({
        key: golf.logout,
        manifest: props.manifest
      })
    };
  }
  /**
   * Show link for pro dashboard only added if a user is pro
   *
   * @returns {React.Component} Component
   * @api private
   */
  renderPro() {
    const props = this.props;
    const eids = this.eids;

    if (props.loggedIn && props.isPro) {
      return (
        <li>
          <Link
            urlArgs={ props.urlArgs }
            { ...props.urls.pro }
            data-eid={ eids.proDashboard }>
            <FormattedMessage id={ golf.proDashboard } />
          </Link>
        </li>
      );
    }
    return null;
  }

  render() {
    const props = this.props;
    const eids = this.eids;

    if (!props.loggedIn) {
      return null;
    }

    return (
      <IntlProvider locale={ props.market } messages={ props.messages }>
        <div className='account-info collapse in'>
          <TrayTitle>
            <Link
              urlArgs={ props.urlArgs }
              { ...props.urls.products }
              data-eid={ eids.manageAccount }
              className='font-primary-bold name ctHidden'>
              { /* props.name is the full name (e.g. "Jane Doe") */ }
              { props.name }
            </Link>
          </TrayTitle>
          <div className='customer-number'>
            <strong>
              <FormattedMessage id={ golf.shopperid } />
            </strong>
            <span className='shopper-id ctHidden'>{ props.shopperId } | </span>
            <strong>
              <FormattedMessage id={ golf.pinLabel } />
            </strong>
            <Link
              urlArgs={ props.urlArgs }
              { ...props.urls.viewPin }
              data-eid={ eids.viewPin }
              className='customer-pin ctHidden'>
              <FormattedMessage id={ golf.viewPin } />
            </Link>
          </div>
          <ul className='list-unstyled quick-links'>
            { this.renderPro() }
            <li>
              <Link
                urlArgs={ props.urlArgs }
                { ...props.urls.products }
                data-eid={ eids.products }>
                <span className='drop-right'>
                  <DropRight />
                </span>
                <FormattedMessage id={ golf.myProducts } />
              </Link>
            </li>
            <li>
              <Link
                urlArgs={ props.urlArgs }
                { ...props.urls.account }
                data-eid={ eids.accountSettings }>
                <span className='drop-right'>
                  <DropRight />
                </span>
                <FormattedMessage id={ golf.accountSettings } />
              </Link>
            </li>
            <li>
              <Link
                urlArgs={ props.urlArgs }
                { ...props.urls.renewals }
                data-eid={ eids.renewals }>
                <span className='drop-right'>
                  <DropRight />
                </span>
                <FormattedMessage id={ golf.renewals } />
              </Link>
            </li>
          </ul>
          <Link
            urlArgs={ props.urlArgs }
            { ...props.urls.products }
            data-eid={ eids.visitMyAccount }
            className='ux-button ux-button-secondary btn btn-purchase'>
            <FormattedMessage id={ golf.visitMyAccount } />
          </Link>
          <Link
            urlArgs={ props.urlArgs }
            { ...props.urls.sso.logout }
            data-eid={ eids.logout }
            className='logout-link'>
            <FormattedMessage id={ golf.logout } />
          </Link>
        </div>
      </IntlProvider>
    );
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @api public
 */
UserDetails.propTypes = {
  name: PropTypes.string,
  shopperId: PropTypes.string,
  loggedIn: PropTypes.bool,
  isPro: PropTypes.bool,
  market: PropTypes.string.isRequired,
  messages: PropTypes.object.isRequired,
  privateLabelId: PropTypes.number,
  manifest: PropTypes.string,
  urlArgs: PropTypes.object,
  urls: PropTypes.object
};

export default UserDetails;
